import React, { useState } from 'react';
import { ImageSliderContainer, ImageSliderImage, ImageSliderArrowBox, ImageSliderBar, ImageSliderBarLeft, ImageSliderBarRight, ImageSliderBarDot } from './styled';

function ImageSlider(props) {

    const list = props.list;
    const length = list.length;

    const [mainIdx, setMainIdx] = useState(props.idx);

    return (
        <ImageSliderContainer>

            <ImageSliderImage>
                <ImageSliderArrowBox>
                    <ImageSliderBarLeft onClick={() => setMainIdx((mainIdx+length-1)%length)}/>
                </ImageSliderArrowBox>

                <img src={list[mainIdx]} alt="" />

                <ImageSliderArrowBox>
                    <ImageSliderBarRight onClick={() => setMainIdx((mainIdx+1)%length)}/>
                </ImageSliderArrowBox>
            </ImageSliderImage>

            <ImageSliderBar>
                {list.map((img, idx) => {
                    return <ImageSliderBarDot selected={idx === mainIdx} onClick={() => setMainIdx(idx)}/>
                })}
            </ImageSliderBar>

        </ImageSliderContainer>
    );
}

export default ImageSlider;